<template>
    <div>
        <div class="color-picker-region">
            <div class="color-picker"></div>
        </div>
    </div>
</template>

<script>

    //import Pickr from '@simonwep/pickr';
    import Pickr from '@simonwep/pickr/dist/pickr.es5.min';
    //import '@simonwep/pickr/dist/themes/classic.min.css';  // 'classic' theme
    //import '@simonwep/pickr/dist/themes/monolith.min.css';  // 'monolith' theme
    import '@simonwep/pickr/dist/themes/nano.min.css';  // 'nano' theme

    export default {
        name: 'ColorPicker',
        props: {
            colorProp: String,
            colorFieldProp: String
        },
        data() {
            return {
                pickr: '',
                color: '',
                colorField: '',
                initialBackgroundColor: null
            }
        },
        mounted: function() {
            this.pickr = Pickr.create({
                el: '.color-picker',
                //container: this.colorField,
                theme: 'nano', // can be 'classic', 'monolith', or 'nano'
                // default accepts color value without '#'
                //default: this.initialBackgroundColor.replace('#', ''),
                //showAlways: true,
                defaultRepresentation: 'CMYK',
                lockOpacity: true,
                swatches: [
                    'cmyk(0%, 100%, 100%, 0%)', //red
                    'cmyk(100%, 0%, 100%, 50%)', //green
                    'cmyk(100%, 100%, 0%, 0%)', //blue
                    'cmyk(0%, 0%, 100%, 0%)', //yellow
                    'cmyk(0%, 0%, 0%, 100%)', //black
                    'cmyk(0%, 0%, 0%, 0%)', //white
                    'cmyk(0%, 100%, 0%, 0%)', //magenta
                    'cmyk(0%, 35%, 100%, 0%)', //orange
                    'cmyk(0%, 0%, 0%, 50%)', //grey
                    'cmyk(0%, 75%, 75%, 35%)', //brown
                    'cmyk(100%, 0%, 0%, 0%)', //cyan
                    'cmyk(0%, 100%, 0%, 50%)', //purple
                    'cmyk(0%, 25%, 20%, 0%)' //pink
                ],
                components: {
                    // Main components

                    //palette: false,
                    preview: true,
                    //opacity: true,
                    hue: true,

                    // Input / output Options
                    interaction: {
                        hex: true,
                        rgba: true,
                        hsla: false,
                        hsva: false,
                        cmyk: true,
                        input: true,
                        cancel: true,
                        clear: true,
                        save: true
                    }
                },
                strings: {
                    save: 'Select',
                //     clear: 'Clear'
                },
            });
        
            this.pickr.on('init', instance => {
                console.log('init', instance);
                console.log('this.colorProp=' + this.colorProp);
                console.log('this.colorFieldProp=' + this.colorFieldProp);

                this.color = this.colorProp;
                this.colorField = this.colorFieldProp;

                this.pickr.setColor(this.color);
            });

            this.pickr.on('change', (color, instance) => {
                console.log('change', color, instance);

                if (color === null) {
                    console.log('value: null');
                } else {
                    var representation = this.pickr.getColorRepresentation();
                    console.log('representation: ' + representation);

                    if (representation == 'CMYK') {
                        console.log('value: ' + color.toCMYK().toString());
                    } else if (representation == 'RGBA') {
                        console.log('value: ' + color.toRGBA().toString());
                    } else if (representation == 'HEXA') {
                        console.log('value: ' + color.toHEXA().toString());
                    }
                }
            });

            this.pickr.on('save', (color, instance) => {
                console.log('save', color, instance);

                if (color === null) {
                    console.log('value: null');
                    this.color = null;
                } else {
                    var representation = this.pickr.getColorRepresentation();
                    console.log('representation: ' + representation);

                    if (representation == 'CMYK') {
                        console.log('value: ' + color.toCMYK().toString());
                        this.color = color.toCMYK();
                    } else if (representation == 'RGBA') {
                        console.log('value: ' + color.toRGBA().toString());
                        this.color = color.toRGBA();
                    } else if (representation == 'HEXA') {
                        console.log('value: ' + color.toHEXA().toString());
                        this.color = color.toHEXA();
                    }
                }

                if (this.colorField == 'varCompany_Colour_1') {
                    this.$emit('colorSelected1', this.color)
                } else if (this.colorField == 'varCompany_Colour_2') {
                    this.$emit('colorSelected2', this.color)
                } else if (this.colorField == 'varCompany_Colour_3') {
                    this.$emit('colorSelected3', this.color)
                }

                instance.hide();
            });

            this.pickr.on('cancel', instance => {
                console.log('cancel', instance);
                instance.hide();
            });
        },
        methods: {
        }
    }
    </script>
